
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import './NotFound.css'

class NotFound extends Component {
  render () {
    return (
      <div id='pnf-container'>
        <div className='pnf-block'>
          <div className='pnf-title'>404</div>
          <div className='pnf-desc'>The page you are looking for isn't here <Link className='pnf-btn' to='/'>Go Back to Home</Link></div> 
        </div>
      </div>
    )
  }
}

export default NotFound
